import React, { FC } from "react";
import { IconButton } from "@xapp/components";
import style from "./style.scss";

/**
 * Get total pages from the total number and the number per page.
 * @param total
 * @param perPage
 * @returns
 */
export function getTotalPages(total: number, perPage: number): number {
    const remains = total / perPage > 1 ? total % perPage : 0;
    return total / perPage > 1 ? Math.trunc(total / perPage) + (remains !== 0 ? 1 : 0) : 1
}

export interface PaginationProps {
    totalPages: number;
    page?: number;
    setPage?(value: number): void;
}

export const Pagination: FC<PaginationProps> = ({
    totalPages,
    page,
    setPage
}: PaginationProps) => {

    return (
        <>
            {totalPages !== 1 ? (
                <div className={style.pagination}>
                    <IconButton iconName={"keyboard_arrow_left"} onClick={() => setPage(page - 1)} disabled={page === 1} />

                    <button
                        onClick={() => setPage(1)}
                        className={`${style.paginationBtn} ${page === 1 ? style.paginationBtnActive : ""}`}
                    >
                        {1}
                    </button>

                    {page > 3 && (
                        <button onClick={() => setPage(page - 3)} className={style.paginationBtn}>
                            ...
                        </button>
                    )}

                    {page === totalPages && totalPages > 3 && (
                        <button onClick={() => setPage(page - 2)} className={style.paginationBtn}>
                            {page - 2}
                        </button>
                    )}
                    {page > 2 && (
                        <button onClick={() => setPage(page - 1)} className={style.paginationBtn}>
                            {page - 1}
                        </button>
                    )}
                    {page !== 1 && page !== totalPages && (
                        <button
                            onClick={() => setPage(page)}
                            className={`${style.paginationBtn} ${style.paginationBtnActive}`}
                        >
                            {page}
                        </button>
                    )}
                    {page < totalPages - 1 && (
                        <button onClick={() => setPage(page + 1)} className={style.paginationBtn}>
                            {page + 1}
                        </button>
                    )}
                    {page === 1 && totalPages > 3 && (
                        <button onClick={() => setPage(page + 2)} className={style.paginationBtn}>
                            {page + 2}
                        </button>
                    )}
                    {page < totalPages - 2 && (
                        <button onClick={() => setPage(page + 3)} className={style.paginationBtn}>
                            ...
                        </button>
                    )}
                    <button
                        onClick={() => setPage(totalPages)}
                        className={`${style.paginationBtn} ${page === totalPages ? style.paginationBtnActive : ""}`}
                    >
                        {totalPages}
                    </button>
                    <IconButton
                        iconName={"keyboard_arrow_right"}
                        onClick={() => setPage(page + 1)}
                        disabled={page === totalPages}
                    />
                </div>
            ) : (
                <></>
            )}
        </>
    );
};
